import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import Link from 'components/Link';
import Button from 'components/Button';

import * as actions from 'actions';
import { getGoalAdding } from 'selectors';

import './style.scss';

class UserGoals extends Component {
  constructor() {
    super();

    this.handleGoalAddingUpdate = this.handleGoalAddingUpdate.bind(this);
    this.handleGoalAddingShow = this.handleGoalAddingShow.bind(this);
    this.handleGoalAddingHide = this.handleGoalAddingHide.bind(this);
    this.handleGoalCreate = this.handleGoalCreate.bind(this);
    this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.renderAddingButton = this.renderAddingButton.bind(this);
  }

  handleGoalAddingShow(e) {
    e.preventDefault();
    this.props.onGoalAddingShow();
  }

  handleGoalAddingHide(e) {
    e.preventDefault();
    this.props.onGoalAddingHide();
  }

  handleGoalCreate(e) {
    e.preventDefault();

    if (this.props.goalText) {
      this.props.onGoalCreate(this.props.goalText);
    }
  }

  handleGoalAddingUpdate(e) {
    this.props.onGoalAddingUpdate(e.target.value);
  }

  handleInputKeyPress(e) {
    if(e.charCode === 13) {
      this.handleGoalCreate(e);
    }
  }

  renderAddingButton() {
    return (
      <Button
        isSmall
        isYellow
        onClick={this.handleGoalAddingShow}
      >
        {__('members.goals.add.button')}
      </Button>
    );
  }

  renderInput() {
    return (
      <div className="add-goal">
        <label>{__('members.goals.add.label')}</label>
        <input
          autoFocus
          type="text"
          value={this.props.goalText}
          onChange={this.handleGoalAddingUpdate}
          onKeyPress={this.handleInputKeyPress}
        />

        <div className="form-buttons">
          <Button
            isYellow
            isDisabled={!this.props.goalText.length}
            onClick={this.handleGoalCreate}
          >
            {__('members.goals.add.save')}
          </Button>
          <div className="cancel-link">
            <span className="separator">{__('members.goals.add.separator')}</span>
            <Link to="_" onClick={this.handleGoalAddingHide}>{__('members.goals.add.cancel')}</Link>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="UserGoalsAddGoal">
        <div className="head">
          <div className="wrapper-small is-padded-top">
            <h1>{__('members.goals.title')}</h1>
            {!this.props.isInputVisible && this.renderAddingButton()}
          </div>
        </div>
        <div className="wrapper-small is-collapsed">
          {this.props.isInputVisible && this.renderInput()}
        </div>
      </div>
    );
  }
}

UserGoals.propTypes = {
  isInputVisible: PropTypes.bool,
  goalText: PropTypes.string,
  onGoalAddingShow: PropTypes.func,
  onGoalAddingHide: PropTypes.func,
  onGoalCreate: PropTypes.func,
  onGoalAddingUpdate: PropTypes.func
};

const mapStateToProps = state => getGoalAdding(state);

const mapDispatchToProps = dispatch => {
  return {
    onGoalAddingShow: () => {
      dispatch(actions.goalAddingShow());
    },
    onGoalAddingHide: () => {
      dispatch(actions.goalAddingHide());
    },
    onGoalCreate: goal => {
      dispatch(actions.goalCreate(
        goal,
        process.env.KOOTH_USER_GOALS,
        __('members.goals.add.successTitle'),
        __('members.goals.add.successMessage')
      ));
    },
    onGoalAddingUpdate: value => {
      dispatch(actions.goalAddingUpdate(value));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserGoals);



/** WEBPACK FOOTER **
 ** ./src/members/Main/UserGoals/UserGoalsAddGoal/index.js
 **/